export default "__VITE_ASSET__da2099b3__"